import { render, staticRenderFns } from "./TheNavbarTopPanelMenuButton.vue?vue&type=template&id=4000e998&scoped=true&"
import script from "./TheNavbarTopPanelMenuButton.vue?vue&type=script&lang=js&"
export * from "./TheNavbarTopPanelMenuButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4000e998",
  null
  
)

export default component.exports